const SUPPORTED_FILE_TYPES = "image/jpeg,image/jpg,image/png, image/tiff, application/pdf";

export { SUPPORTED_FILE_TYPES };
